import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeart, faComment } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Chip from 'Root/App/Item/Chip'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'

import styles from '../index.module.css'

interface ReviewInfoProps {
  comments: number
  onClick?: () => void
}

library.add(faHeart, faComment)

const ReviewInfo = ({ comments, onClick }: ReviewInfoProps) => {
  return (
    <div className={styles.reviewInfoWrapper}>
      <Chip
        icon={
          <FontAwesomeIcon
            className={styles.reviewInfoLikesIcon}
            icon={['fas', 'comment']}
          />
        }
        onClick={onClick}
      >
        <span>
          <Title size="XS" maxRows={2}>
            {comments}
          </Title>
          <PreTitle className="text-brand-main" size="XS">
            <u>Commenti degli studenti</u>
          </PreTitle>
        </span>
      </Chip>
    </div>
  )
}

export default ReviewInfo
